module.exports = __webpack_public_path__ + "media/images/temp/ribbon-9-0eee12d822268e22139a958b0d063108.png";